/* import React, { useEffect, useState } from "react";

import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./FellowshipCourses.css"; // ✅ Import the CSS

export default function Fellowship_Courses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const API = "https://course-selling-backend-2-rr1n.onrender.com";

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const res = await axios.get(`${API}/api/courses`);
      console.log("Fetched courses:", res.data);
      const filtered = res.data.filter(
        (course) => course.level === "Fellowship"
      );
      setCourses(filtered);
    } catch (err) {
      console.error("Error fetching Fellowship courses:", err);
    } finally {
      setLoading(false);
    }
  };

  // 💳 Razorpay Payment Integration
  const handleBuy = async (course) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Please login first to continue!");
        return;
      }

      const orderRes = await axios.post(
        `${API}/api/payment/create-order`,
        { amount: course.price },
        { headers: { "x-auth-token": token } }
      );

      const { order } = orderRes.data;

      const options = {
        key: "rzp_live_RUUK4vJNXWL4ZP", // ⚡ Replace with your live Razorpay key
        amount: order.amount,
        currency: order.currency,
        name: "Medby Academy",
        description: course.title,
        order_id: order.id,
        handler: async function (response) {
          try {
            const verifyRes = await axios.post(
              `${API}/api/payment/verify`,
              {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                courseId: course._id,
              },
              { headers: { "x-auth-token": token } }
            );

            alert(verifyRes.data.message);
            window.location.href = "/mycourses";
          } catch (err) {
            alert("❌ Payment Verification Failed!");
          }
        },
        prefill: {
          name: "Student",
          email: "student@example.com",
          contact: "9999999999",
        },
        theme: { color: "#007bff" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("Payment Error:", err);
      alert("Something went wrong during payment!");
    }
  };

  return (
    <>
      <Navbar />
      <section className="fellowship-section">
        <section className="fellowship-hero">
          <h1 className="fellowship-title">🎓 Fellowship Courses</h1>
          <p className="fellowship-subtitle">
            Explore our latest Fellowship Programs designed to boost your career
            growth.
          </p>
        </section>

        {loading ? (
          <p style={{ textAlign: "center" }}>Loading courses...</p>
        ) : courses.length === 0 ? (
          <p style={{ textAlign: "center" }}>
            No Fellowship courses available.
          </p>
        ) : (
          <div className="courses-grid">
            {courses.map((course) => (
              <div key={course._id} className="course-card">
                <img
                  src={
                    course.thumbnail.startsWith("http")
                      ? course.thumbnail
                      : `${API}${course.thumbnail}`
                  }
                  alt={course.title}
                  className="course-img"
                />

                <div className="course-content">
                  <h3 className="course-title">{course.title}</h3>
                  <p className="course-desc">
                    {course.description.slice(0, 90)}...
                  </p>
                  <div className="course-footer">
                    <span className="course-price">₹{course.price}</span>
                    <button
                      onClick={() => handleBuy(course)}
                      className="buy-btn"
                    >
                       Enroll & Pay
                    </button>
                  </div>
                </div>  
              </div>
            ))}
          </div>
        )}
      </section>
      <Footer />
    </>
  );
}
*/


/*
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // ✅ Add navigation
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./CertificateCourses.css";
import image from '../image/main-logo.png';
export default function Certificate_Courses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const API = "https://course-selling-backend-2-rr1n.onrender.com";
  const navigate = useNavigate(); // ✅ Hook for navigation

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const res = await axios.get(`${API}/api/courses`);
      const filtered = res.data.filter((course) => course.level === "Certificate");
      setCourses(filtered);
    } catch (err) {
      console.error("Error fetching Certificate courses:", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ New function: Navigate to course details page
  const handleViewCourse = (courseId) => {
    navigate(`/viewcourse/${courseId}`);
  };

  const handleClick = () => {
    navigate("/Contact"); // yahan "/about" aapka target route hai
  };
  return (
    <>
      <Navbar />
      <section className="fellowship-section">
        <section className="fellowship-hero">
          <h1 className="fellowship-title"> Certificate Courses</h1>
          <p className="fellowship-subtitle">
            Explore our latest Certificate Programs designed to boost your career growth.
          </p>
        </section>

        {loading ? (
          <p style={{ textAlign: "center" }}>Loading courses...</p>
        ) : courses.length === 0 ? (
          <p style={{ textAlign: "center" }}>No Certificate courses available.</p>
        ) : (
          <div className="courses-grid">
            {courses.map((course) => (
              <div key={course._id} className="fellowship-card">
               
                <img
                  src={
                    course.thumbnail.startsWith("http")
                      ? course.thumbnail
                      : `${API}${course.thumbnail}`
                  }
                  alt={course.title}
                  className="fellowship-img"
                />

               
                <div className="fellowship-content">
                  <h3 className="fellowship-title-text">{course.title}</h3>
                  <h4 className="fellowship-price">₹ {course.price}</h4>
                  <p className="fellowship-Mode">Mode : {course.mode}</p>
                  <p className="fellowship-Mode">Eligibility Criteria : {course.eligibility} </p>

                  <div className="fellowship-buttons">
                    <button onClick={handleClick} className="enquire-btn-cc">Enroll & Pay</button>
                    <button
                      className="view-btn"
                      onClick={() => handleViewCourse(course._id)}
                    >
                      View Course
                    </button>
                  </div>

                  
                    <div className="academy-info">
                      <img
                        src={image}
                        alt="academy"
                      />
                      <p>Medby Academy</p>

                    </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      <Footer />
    </>
  );
}
*/


import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./CertificateCourses.css";
import image from "../image/main-logo.png";

export default function Certificate_Courses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const API = "https://course-selling-backend-2-rr1n.onrender.com";
  const navigate = useNavigate();

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const res = await axios.get(`${API}/api/courses`);
      const filtered = res.data.filter(
        (course) => course.level === "Certificate"
      );
      setCourses(filtered);
    } catch (err) {
      console.error("Error fetching Certificate courses:", err);
    } finally {
      setLoading(false);
    }
  };

  // 👁 View course details
  const handleViewCourse = (courseId) => {
    navigate(`/viewcourse/${courseId}`);
  };

  // 💳 Razorpay Payment
  const handleBuy = async (course) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Please login first to continue!");
        navigate("/login");
        return;
      }

      // 1️⃣ Create Order
      const orderRes = await axios.post(
        `${API}/api/payment/create-order`,
        { amount: course.price },
        { headers: { "x-auth-token": token } }
      );

      const { order } = orderRes.data;

      // 2️⃣ Razorpay Options
      const options = {
        key: "rzp_live_RUUK4vJNXWL4ZP", // 🔴 Test key ho to test key use karo
        amount: order.amount,
        currency: order.currency,
        name: "Medby Academy",
        description: course.title,
        order_id: order.id,

        handler: async function (response) {
          try {
            // 3️⃣ Verify Payment
            const verifyRes = await axios.post(
              `${API}/api/payment/verify`,
              {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                courseId: course._id,
              },
              { headers: { "x-auth-token": token } }
            );

            alert(verifyRes.data.message);
            navigate("/mycourses");
          } catch (err) {
            alert("❌ Payment verification failed!");
          }
        },

        prefill: {
          name: "Student",
          email: "student@example.com",
          contact: "9999999999",
        },

        theme: {
          color: "#007bff",
        },
      };

      // 4️⃣ Open Razorpay
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("Payment Error:", err);
      alert("Something went wrong during payment!");
    }
  };

  return (
    <>
      <Navbar />

      <section className="fellowship-section">
        <section className="fellowship-hero">
          <h1 className="fellowship-title">Certificate Courses</h1>
          <p className="fellowship-subtitle">
            Explore our latest Certificate Programs designed to boost your career growth.
          </p>
        </section>

        {loading ? (
          <p style={{ textAlign: "center" }}>Loading courses...</p>
        ) : courses.length === 0 ? (
          <p style={{ textAlign: "center" }}>
            No Certificate courses available.
          </p>
        ) : (
          <div className="courses-grid">
            {courses.map((course) => (
              <div key={course._id} className="fellowship-card">
                <img
                  src={
                    course.thumbnail.startsWith("http")
                      ? course.thumbnail
                      : `${API}${course.thumbnail}`
                  }
                  alt={course.title}
                  className="fellowship-img"
                />

                <div className="fellowship-content">
                  <h3 className="fellowship-title-text">{course.title}</h3>
                  <h4 className="fellowship-price">₹ {course.price}</h4>
                  <p className="fellowship-Mode">Mode : {course.mode}</p>
                  <p className="fellowship-Mode">
                    Eligibility Criteria : {course.eligibility}
                  </p>

                  <div className="fellowship-buttons">
                    <button
                      onClick={() => handleBuy(course)}
                      className="enquire-btn-cc"
                    >
                      Enroll & Pay
                    </button>

                    <button
                      className="view-btn"
                      onClick={() => handleViewCourse(course._id)}
                    >
                      View Course
                    </button>
                  </div>

                  <div className="academy-info">
                    <img src={image} alt="academy" />
                    <p>Medby Academy</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      <Footer />
    </>
  );
}